<template>
  <span>
    <v-app-bar
      color="white"
      fixed
      style="border-radius: 0;">
      <v-toolbar-title>
        <v-btn
          to="/"
          text
          color="secondary"
          height="40px">
          <img
            src="logo_newmat.svg"
            alt="Plafond et mur tendus NEWMAT Annecy"
            height="30px">
        </v-btn>
      </v-toolbar-title>

      <v-spacer/>

      <v-toolbar-items class="menunav">
        <v-btn
          to="/#services"
          text
          color="secondary">Expertise</v-btn>
        <v-btn
          to="/#realisations"
          text
          color="secondary">Réalisations</v-btn>
        <v-btn
          to="/#technologie"
          text
          color="secondary">Technologie</v-btn>
        <v-btn
          to="/#devis"
          text
          color="secondary">Devis</v-btn>
        <v-btn
          to="/#contact"
          text
          color="secondary">Contact</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <section
      id="services">
      <v-parallax
        src="fond7_noblur.jpg"
        top
        height="380"
        class="gradienthero">
        <v-overlay
          :absolute="true"
          :value="true"
        >
          <v-layout
            column
            align-center
            justify-center>
            <div class="display-2 font-weight-bold white--text mb-4 text-center text-uppercase">L’équipe</div>
            <em>L'équipe NEWMAT Annecy Plafond-tendu</em>
          </v-layout>
        </v-overlay>
      </v-parallax>
    </section>
    <section>
      <v-container grid-list-xl>
        <v-layout
          wrap
          justify-center
          class="my-12">
          <v-flex
            xs12
            sm12>
            <v-card-text>
              <p><a href="/service.htm">La pose</a> d'un <a
                href="http://newmat.com/questions-answers/"
                target="_blank">plafond
                tendu NEWMAT</a>, peut être éffectueée par
                un seul poseur
              </p>
              <p>Le commercial, les visites de chantiers, les devis gratuit, ont lieux,
              sur rendez-vous aux horaires qui vous conviennent, alors n'hésitez
              pas!
              </p>
            </v-card-text>
          </v-flex>
          <v-flex
            sm6>
            <div class="video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/RH3Z3hqm_PI"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen/>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-footer color="black">
      <v-layout
        wrap
        align-center
        class="white--text text-center">
        <v-flex xs4>
          <a
            href="https://www.newmat.com"
            target="_blank">
            <img
              class="logofooter"
              src="logo_newmat_white_white_solo.svg"
              alt="NewMat Plafond Tendu">
          </a>
        </v-flex>
        <v-flex xs4>
          <a
            href="https://www.plafonds-tendus.fr"
            target="_blank"
            class="white--text font-weight-bold textfooter">
            www.plafonds-tendus.fr
          </a>
        </v-flex>
        <v-flex xs4>
          <a
            href="https://www.cma-74.fr"
            target="_blank">
            <img
              class="logofooter"
              src="logochambredesmetiers.png"
              alt="Chambre des métiers de Haute-Savoie">
          </a>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Entreprise
            <ul>
              <li>
                <a href="../entreprise.htm">Entreprise</a>
              </li>
              <li>
                <a href="../equipe.htm">Équipe</a>
              </li>
              <li>
                <a href="../partenaire.htm">Partenaires</a>
              </li>
              <li>
                <a href="../localisation.htm">Localisation</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Prestations
            <ul>
              <li>
                <a href="../prestations.htm">Prestations</a>
              </li>
              <li>
                <a href="../aspect.htm">Aspect</a>
              </li>
              <li>
                <a href="../technique.htm">Technique</a>
              </li>
              <li>
                <a href="../Garantie-qualité.htm">Garanties qualité</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Services
            <ul>
              <li>
                <a href="../service.htm">Services</a>
              </li>
              <li>
                <a href="../electricite-spot-luminnaire.htm">Électricité</a>
              </li>
              <li>
                <a href="../menuiserie-bois-pvc.htm">Menuiserie</a>
              </li>
              <li>
                <a href="../acces-au-plenum.htm">Accés à l’ancien plafond</a>
              </li>
              <li>
                <a href="../isolation-thermique-phonique.htm">Isolation thermique et phonique</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Infos
            <ul>
              <li>
                <a href="../Processus fabrication.htm">Processus de fabrication</a>
              </li>
              <li>
                <a href="../nettoyage.htm">Nettoyage</a>
              </li>
              <li>
                <a href="../lisse-plafond-tendu.htm">Les lisses</a>
              </li>
              <li>
                <a href="../entretien-des-lisses.htm">Entretien des Lisses</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex xs12>
          <div class="white--text textfooter">
            &copy;
            1995 - {{ datesite }} |
            Site web réalisé par <a
              class="white--text font-weight-bold"
              href="https://www.thecompagnie.eu"
              target="_blank">TheCompagnie</a> |
            <router-link
              to="/admin"
              class="white--text"
            >
              Accès administration
            </router-link>
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  computed: {
    datesite () {
      return moment(new Date()).format('YYYY')
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.logoparalax{
  @media screen and (max-width: 550px) {
    width: 70vw !important;
  }
  width: 50vw !important;
}
.pastillegarantie{
  position: absolute;
  top: -3em;
  left:-3em;
  width:70px;
  @media screen and (max-width: 550px) {
    top: -2em;
    left:-2em;
    width:50px;
  }
}
.menunav{
  .v-btn{
    @media screen and (max-width: 550px) {
      padding-left: 2px !important;
      padding-right: 2px !important;
    }
  }
  @media screen and (max-width: 550px) {
    font-size: 0.6em !important;
  }
}
</style>
